import React, { useEffect, useReducer } from 'react';
import { setTheme } from './state/ThemeCreator.action';
import { ThemeCreatorReducer } from './state/ThemeCreator.state';
import ThemeWrapper from './ThemeWrapper';
import { useHost } from '../host/useHost';
import { IThemeCreatorProps } from './types';

export function ThemeCreator({ children, LoadingComponent }: IThemeCreatorProps) {
    const [state, dispatch] = useReducer(ThemeCreatorReducer, {
        theme: null,
        themeObject: null,
        isLoading: true,
    });
    useHost(() => dispatch(setTheme()));
    const { isLoading, theme } = state;

    useEffect(() => {
        dispatch(setTheme());
    }, []);

    if (isLoading) {
        return (
            <div
                style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {LoadingComponent}
            </div>
        );
    }

    return (
        <ThemeWrapper theme={theme}>
            {React.Children.map(children, (child) => {
                return child;
            })}
        </ThemeWrapper>
    );
}
